var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"legal-info-component"},[_c('div',{staticClass:"legal-info-text-content",staticStyle:{"margin-top":"-14px"},domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }